import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MaterialModule } from 'src/app/material.module';
import { CmsService } from 'src/app/modules/cms/service/cms.service';

@Component({
  selector: 'app-view-content-body',
  imports: [
    MaterialModule,
    TablerIconsModule,
    MatNativeDateModule,
    NgScrollbarModule,
    CommonModule,
    RouterModule,
    FormsModule
  ],
  templateUrl: './view-content-body.component.html',
  styleUrl: './view-content-body.component.scss'
})

export class ViewContentBodyComponent {
  langCode: string;
  loading: boolean = false;
  contentEntryData: any;
  dir: string;
  constructor(private service: CmsService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer) {
  }

  ngAfterViewInit() {
    this.getContentBodyByLangAndId();
  }

  getContentBodyByLangAndId(): void {
    this.loading = true; // Start loading
    const lang = this.route.snapshot.paramMap.get('lang') ?? "en"; // 'en' or 'ar'
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.dir = lang == "en" ? "ltr" : "rtl";
    this.service.getContentBodyByLangAndId('public/content/entry', lang, id).subscribe({
      next: (response: any) => {
        this.contentEntryData = {
          title: response.data.title,
          body: this.sanitizer.bypassSecurityTrustHtml(this.sanitizeHtml(response.data.body))
        };
      },
      error: (err) => {
        this.loading = false; // Stop loading
      },
      complete: () => {
        this.loading = false; // Stop loading
      }
    });
  }

  sanitizeHtml(body: string): string {
    return body.replace(/&nbsp;/g, ' ')
      .replace(/style="[^"]*"/g, ''); // strips inline styles
  }
}